import DownloadManager from 'cordova-plugin-android-downloadmanager'
import SanitizeFilename from 'sanitize-filename'
import EnvironmentUtils from './environmentUtils'

const ANDROID_DOWNLOADS_PATH = 'download/'
const IOS_DOWNLOADS_PATH = './'
const LOCAL_FILE_SYSTEM_PERSISTENT_DOCUMENTS = 5

async function writeFileToDownloadsAsync (name, blob)
{
    name = SanitizeFilename(name)
    
    if (cordova.platformId == 'browser') return browserDownloadFile(name, blob)

    const file = {}
    file.name = name
    file.type = blob.type
    file.data = blob
    file.size = blob.size

    console.log('Writing', file, 'to downloads')

    const fileSystemType = cordova.platformId == 'android' ?
        LocalFileSystem.PERSISTENT : LOCAL_FILE_SYSTEM_PERSISTENT_DOCUMENTS
    const downloadsDirectory = cordova.platformId == 'android' ?
        ANDROID_DOWNLOADS_PATH : IOS_DOWNLOADS_PATH

    const fs = await requestFileSystemAsync(fileSystemType, 0)
    console.log('Accessing FileSystem', fs)

    const directoryEntry = await getDirectoryAsync(fs.root, downloadsDirectory, { create: true, exclusive: false })
    console.log('Accessing DirectoryEntry', directoryEntry)

    const fileEntry = await getFileAsync(directoryEntry, file.name, { create: true, exclusive: false })
    console.log('Accessing FileEntry', fileEntry)

    const fileWriter = await createWriterAsync(fileEntry)
    console.log('Using FileWriter', fileWriter)
    
    fileWriter.onwriteend = () =>
    {
        console.log(`Successfully wrote file ${JSON.stringify(file)} to ${fileEntry.nativeURL}`)
    }
    
    fileWriter.onerror = error =>
    {
        console.log(`Could not write file ${JSON.stringify(file)} to ${fileEntry.nativeURL} with DirectoryEntry ${directoryEntry} and FileSystem ${fs}`)

        throw error
    }

    fileWriter.write(file.data)

    if (cordova.platformId == 'android')
    {
        DownloadManager.addCompletedDownload
        ({
            title: file.name,
            mimeType: file.type,
            description: 'Téléchargé depuis ' + EnvironmentUtils.cityName,
            length: file.size,
            showNotification: true,
            path: decodeURIComponent(fileEntry.nativeURL.replace('file:///', ''))
        }, (error, id) => {if (error) console.error(error)})
    }

    console.log('Opening', file)
    cordova.plugins.fileOpener2.open(fileEntry.nativeURL, file.type, {error: console.error})
}

function browserDownloadFile (name, blob)
{
    const link = document.createElement('a');
    // create a blobURI pointing to our Blob
    link.href = URL.createObjectURL(blob);
    link.download = name;
    // some browser needs the anchor to be in the doc
    document.body.append(link);
    link.click();
    link.remove();
    // in case the Blob uses a lot of memory
    window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
}

function requestFileSystemAsync (type, size)
{
    return new Promise((resolve, reject) =>
    {
        window.requestFileSystem(type, size, resolve, reject)
    })
}

function getDirectoryAsync (directoryEntry, path, options)
{
    return new Promise((resolve, reject) =>
    {
        directoryEntry.getDirectory(path, options, resolve, reject)
    })
}

function getFileAsync (directoryEntry, path, options)
{
    return new Promise((resolve, reject) =>
    {
        directoryEntry.getFile(path, options, resolve, reject)
    })
}

function createWriterAsync (fileEntry)
{
    return new Promise((resolve, reject) =>
    {
        fileEntry.createWriter(resolve, reject)
    })
}

function promptFiles (fileType)
{
    return new Promise((resolve, reject) =>
    {
        const input = document.createElement('input')

        input.type = 'file'
        input.accept = fileType
        input.style.display = 'none'

        input.addEventListener('change', () =>
        {
            resolve(input.files)
            document.body.removeChild(input)
        })

        document.body.appendChild(input)
        input.click()
    })
}

function promptImages ()
{
    return promptFiles('image/*')
}

/**
 * @param {string} url 
 */
function fetchLocalFile (url)
{
    return new Promise(function (resolve, reject)
    {
        var xhr = new XMLHttpRequest
        xhr.onload = function ()
        {
            resolve(new Response(xhr.response, { status: xhr.status }))
        }
        xhr.onerror = function ()
        {
            reject(new TypeError('Local request failed'))
        }

        xhr.open('GET', url)
        xhr.responseType = 'arraybuffer';
        xhr.send(null)
    })
}

export default { writeFileToDownloadsAsync, promptFiles, promptImages, fetchLocalFile }


// WEBPACK FOOTER //
// ./src/utils/fileUtils.js